import { Form, message } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useState } from "react";

export const useAddOnService = () => {
  const [addOnServices, setAddOnServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingService, setEditingService] = useState(null);
  const [fileList, setFileList] = useState([]); // State to manage file list
  const [form] = Form.useForm();

  // Fetch all Add-On Services
  const fetchAddOnServices = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "/api/addonservices/getalladdonservices"
      );
      setAddOnServices(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch Add-On Services:", error);
      setLoading(false);
    }
  };
  const openModal = (service = null) => {
    setEditingService(service);
    if (service) {
      form.setFieldsValue({
        ...service,
        dateApplied: [
          dayjs(service.dateApplied.startDate),
          dayjs(service.dateApplied.endDate),
        ],
      });
    } else {
      form.resetFields();
    }
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingService(null);
    setFileList([]); // Reset the file list when closing the modal
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/addonservices/delete/${id}`);
      message.success("Service deleted successfully");
      fetchAddOnServices();
    } catch (error) {
      message.error("Failed to delete service");
    }
  };

  const handleFormSubmit = async (values) => {
    const { dateApplied, ...rest } = values;

    // Ensure dateApplied is an array with two valid dates
    if (dateApplied && dateApplied.length === 2) {
      const formData = new FormData();

      // Append the form values
      formData.append("serviceName", rest.serviceName);
      formData.append("kindOfService", rest.kindOfService);
      formData.append("chargeType", rest.chargeType);
      formData.append("servicePrice", rest.servicePrice);
      formData.append("serviceDescription", rest.serviceDescription);

      // Format the dates and append them to formData
      formData.append("dateApplied[startDate]", dateApplied[0].toISOString()); // Start date
      formData.append("dateApplied[endDate]", dateApplied[1].toISOString()); // End date

      // Append the photo if it exists
      if (fileList.length > 0) {
        formData.append("photo", fileList[0].originFileObj); // Append the file
      }

      try {
        if (editingService) {
          // Update existing service
          await axios.put(
            `/api/addonservices/update/${editingService._id}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          message.success("Service updated successfully");
        } else {
          // Create new service
          await axios.post("/api/addonservices/create", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          message.success("Service created successfully");
        }
        fetchAddOnServices();
        handleCancel();
      } catch (error) {
        message.error("Failed to save service");
      }
    } else {
      message.error("Please select a valid date range.");
    }
  };

  // Handle file upload
  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList); // Set file list for form submission
  };
  return {
    fetchAddOnServices,
    addOnServices,
    loading,
    isModalVisible,
    editingService,
    fileList,
    form,
    handleFormSubmit,
    handleUploadChange,
    handleDelete,
    openModal,
    handleCancel,
  };
};
